module.exports = __webpack_public_path__ + "img/anewitem-male-shoe.15549674.svg";